import { render, staticRenderFns } from "./01drugGenelist.vue?vue&type=template&id=6de6781c&"
import script from "./01drugGenelist.vue?vue&type=script&lang=js&"
export * from "./01drugGenelist.vue?vue&type=script&lang=js&"
import style0 from "./01drugGenelist.vue?vue&type=style&index=0&id=6de6781c&prod&scpoed=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports